import * as React from "react";

function SvgKebab(props) {
  return <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M9.2 2.667a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0zM9.2 8a1.2 1.2 0 11-2.4 0 1.2 1.2 0 012.4 0zM8 14.533a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4z" fill="#000" /></svg>;
}

export default SvgKebab;